import React, { useState } from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import api from '@/utils/api';
import { toast } from 'sonner';

// PayPal Client ID (sandbox)
const PAYPAL_CLIENT_ID = "EMcye6vExqYLkIwm6gbzoZrdc40YnyahGQ4uViBOeBsdTHrAGTWg7LfJZV1ZZCbINXnY2Pl844ujiSkC";

export default function PayPalPayment({ amount, onSuccess, videoId = null, featureType = null }) {
  const [processing, setProcessing] = useState(false);

  const createOrder = async () => {
    try {
      setProcessing(true);
      const response = await api.post('/payments/paypal/create-order', {
        video_id: videoId,
        feature_type: featureType,
        amount_usd: amount
      });

      return response.data.paypal_order_id;
    } catch (error) {
      toast.error('Erreur création commande PayPal');
      throw error;
    } finally {
      setProcessing(false);
    }
  };

  const onApprove = async (data) => {
    try {
      setProcessing(true);
      const response = await api.post(`/payments/paypal/capture/${data.orderID}`);
      
      toast.success('✅ Paiement réussi !');
      if (onSuccess) {
        onSuccess(response.data);
      }
    } catch (error) {
      toast.error('Erreur capture paiement');
      console.error(error);
    } finally {
      setProcessing(false);
    }
  };

  const onError = (err) => {
    console.error('Erreur PayPal:', err);
    toast.error('Erreur PayPal. Veuillez réessayer.');
    setProcessing(false);
  };

  return (
    <PayPalScriptProvider 
      options={{ 
        clientId: PAYPAL_CLIENT_ID,
        currency: "USD"
      }}
    >
      <div className="w-full">
        {processing && (
          <div className="text-center text-white mb-2">
            <p className="text-sm">Traitement en cours...</p>
          </div>
        )}
        <PayPalButtons
          style={{ 
            layout: "vertical",
            color: "blue",
            shape: "rect",
            label: "pay"
          }}
          createOrder={createOrder}
          onApprove={onApprove}
          onError={onError}
          disabled={processing}
        />
      </div>
    </PayPalScriptProvider>
  );
}
